module.exports = __webpack_public_path__ + "static/media/home_bg_video.337d0e72.mp4";